import { SIDEBAR_COMMON_STYLE } from "../../siteInfo/SiteStyle";
const categoryList = {
  categoryContainer: {
    width: "90%",
    maxWidth: 375,
    marginRight: "auto",
    marginLeft: "auto",
    marginBottom: 18,
    background: "white",
    borderRadius: 3,
    overflow: "hidden",
  },
  link: {
    color: "black",
    textDecoration: "none",
  },
  categoryHeader: {
    color: SIDEBAR_COMMON_STYLE.color,
    fontSize: SIDEBAR_COMMON_STYLE.headerFontSize,
    backgroundColor: SIDEBAR_COMMON_STYLE.mainColor,
    paddingTop: 9,
    paddingBottom: 9,
    textAlign: "center",
  },
  categoriesList: {
    width: "100%",
    maxHeight: 450,
    padding: 0,
    overflow: "auto",
  },
  subHeader: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    fontSize: 15,
    backgroundColor: "white",
    transition: "all .3s ease",
    "&:hover": {
      color: SIDEBAR_COMMON_STYLE.mainColor,
      backgroundColor: "#f3f3f3",
    },
  },
  subHeaderIcon: {
    verticalAlign: "middle",
  },
  subHeaderName: {},
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 14,
    cursor: "pointer",
    transition: "all .3s ease",
    "&:hover": {
      color: SIDEBAR_COMMON_STYLE.mainColor,
      backgroundColor: "#f3f3f3",
    },
  },
  listItemIcon: {
    verticalAlign: "middle",
    fontSize: 15,
    paddingLeft: 18,
  },
  listName: {},
  listCount: {
    width: "9%",
    minWidth: 18,
    color: SIDEBAR_COMMON_STYLE.color,
    textAlign: "center",
    backgroundColor: SIDEBAR_COMMON_STYLE.mainColor,
    borderRadius: 3,
  },
};
export default categoryList;
